import { Star, Quote } from "lucide-react";

export default function TestimonialCard({ t, index = 0 }) {
    const initials = t.name
        .split(" ")
        .map((s) => s[0])
        .slice(0, 2)
        .join("");
    return (
        <article
            data-testid={`testimonial-${index}`}
            className="card-ns p-7 sm:p-8 h-full flex flex-col"
        >
            <div className="flex items-center gap-1 text-[var(--ns-blue)] mb-4">
                {[...Array(5)].map((_, i) => (
                    <Star
                        key={i}
                        className="w-4 h-4 fill-[var(--ns-blue)]"
                        strokeWidth={0}
                    />
                ))}
                <span className="ml-2 text-xs font-bold tracking-[0.18em] uppercase text-[var(--ns-blue)]">
                    Anbefaler
                </span>
            </div>
            <Quote className="w-7 h-7 text-[var(--ns-blue)]/20 mb-3" />
            <p className="text-[var(--ns-text)] text-base leading-relaxed flex-1">
                {t.text}
            </p>
            <div className="mt-6 pt-5 border-t border-[var(--ns-border)] flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[var(--ns-blue)] text-white grid place-items-center font-display font-extrabold text-sm">
                    {initials}
                </div>
                <div>
                    <div className="font-display font-bold text-sm text-[var(--ns-text)]">
                        {t.name}
                    </div>
                    <div className="text-xs text-[var(--ns-muted)]">
                        Facebook-anmeldelse · {t.date}
                    </div>
                </div>
            </div>
        </article>
    );
}
